module.exports = __webpack_public_path__ + "img/bg.08f69e42.png";